export default function StudentGrid({
  students,
  onSelect,
  progress = {},
  totalTasksByStudent = {},
  optionalCompleted = {},
  showTasks = true,
}) {
  const count = students.length;
  const density = count <= 10 ? "small" : count <= 20 ? "medium" : "large";
  const baseColumns = Math.ceil(Math.sqrt(count));
  const extraColumns = count > 15 ? 2 : 1;
  const columns = Math.max(1, Math.min(
    count || 1,
    showTasks ? 6 : 8,
    baseColumns + (showTasks ? 0 : extraColumns)
  ));

  return (
    <div
      className={`ct-student-grid is-${density}-class${count > 30 ? " is-overflow" : ""}`}
      style={{ "--student-columns": columns }}
      aria-label={`${count} leerlingen`}
    >
      {students.map((student) => {
        const completed = progress[student.id] || 0;
        const totalTasks = totalTasksByStudent[student.id] || 0;
        const hasOptionalStar = optionalCompleted[student.id];
        const isComplete = totalTasks > 0 && completed >= totalTasks;
        const isProgress = completed > 0 && !isComplete;
        const initials = student.student_name?.trim()?.charAt(0)?.toUpperCase() || "?";
        const progressPercent = totalTasks > 0
          ? Math.min(100, Math.round((completed / totalTasks) * 100))
          : 0;

        return (
          <button
            key={student.id}
            onClick={() => onSelect(student)}
            className={`ct-student-card${isComplete ? " is-complete" : ""}${isProgress ? " is-progress" : ""}`}
          >
            {isComplete ? (
              <span className="ct-complete-check" title="Alles klaar">✓</span>
            ) : hasOptionalStar ? (
              <span className="ct-optional-star" title="Magje taak gedaan">
                ⭐
              </span>
            ) : null}

            <span className="ct-student-initial" aria-hidden="true">
              {initials}
            </span>
            <span className="ct-student-name">
              {student.student_name}
            </span>

            {totalTasks > 0 ? (
              <>
                <span className="ct-student-progress-label">
                  {completed} van {totalTasks} klaar
                </span>
                <span className="ct-progress-track" aria-hidden="true">
                  <span className="ct-progress-fill" style={{ width: `${progressPercent}%` }} />
                </span>
              </>
            ) : (
              <span className="ct-student-progress-label">
                Geen taken
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
